import React from "react";
import { EditOutlined, LockOpen, Save } from "@mui/icons-material";
import { IconButton } from "@mui/material";

interface Props {
  icon: {
    edit?: boolean;
    save?: boolean;
    unlock?: boolean;
  };
  disabled?: boolean;
  onEdit?: () => void;
  onSave?: () => void;
  onUnlock?: () => void;
}

export const ActionIcon: React.FC<Props> = ({
  icon,
  disabled,
  onEdit,
  onSave,
  onUnlock,
}) => {
  let onClick: (() => void) | undefined;

  if (icon.edit) {
    onClick = onEdit;
  } else if (icon.save) {
    onClick = onSave;
  } else if (icon.unlock) {
    onClick = onUnlock;
  }

  return (
    <IconButton size="small" disabled={disabled} onClick={onClick}>
      {icon.edit && <EditOutlined fontSize="small" />}
      {icon.save && <Save fontSize="small" />}
      {icon.unlock && <LockOpen fontSize="small" />}
    </IconButton>
  );
};
